
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminosycondiciones-pagocomprasonline",
      function () {
        return require("private-next-pages/terminosycondiciones-pagocomprasonline/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminosycondiciones-pagocomprasonline"])
      });
    }
  